import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function logoutRequest(isLoading) {
  return {
    type: actionsTypesMembers.LOGOUT_REQUEST,
    isLoading,
  }
}
function logoutFailure(isError) {
  return {
    type: actionsTypesMembers.LOGOUT_FAILURE,
    isError,
  }
}
function logoutSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.LOGOUT_SUCCESS,
    isSuccess,
  }
}
export function fetchLogoutAction() {
  return function(dispatch, getState) {

    dispatch(logoutRequest(true))

    return backendMembers.logout()
      .then(response => {
        dispatch(logoutRequest(false))
        dispatch(logoutSuccess(true))
      })
      .catch(error => {
        dispatch(logoutRequest(false))
        dispatch(logoutFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Authentification/Logout.js